import { supabase } from "../supabaseClient";
import { v4 } from "uuid";

const storageService = {
  upload: async (file) => {
    console.log("file", file);
    const { data, error } = await supabase.storage
      .from("classifieds")
      .upload("/public/" + v4() + ".png", file);
    if (error) {
      throw error;
    }
    return data;
  },
  uploadMany: async (files) => {
    const result = await Promise.all(
      files.map(async ({ file }) => {
        const { data, error } = await supabase.storage
          .from("classifieds")
          .upload("/public/" + v4() + ".png", file);
        if (error) {
          throw error;
        }
        return data;
      })
    );
    return result;
  },
  update: async (file, path) => {
    console.log(file, path);
    // await supabase.storage.from("classifieds").remove([path]);
    const { data, error } = await supabase.storage
      .from("classifieds")
      .update(path, file, {
        cacheControl: "3600",
        upsert: true,
      });
    if (error) {
      throw error;
    }
    return data;
  },
  publicUrl: (path) => {
    if (!path) return null;
    if (path.startsWith("public/")) {
      const { data } = supabase.storage.from("classifieds").getPublicUrl(path, {
        transform: {
          quality: 50,
        },
      });
      return data.publicUrl + `&v=${Date.now()}`;
    } else if (path.startsWith("images/")) {
      const ext = path.split(".").pop();
      return `https://collive.com/wp-content/uploads/awpcp/${path.replace(
        `.${ext}`,
        "-large"
      )}.${ext}?`;
    }
  },
  remove: async (file) => {
    const { data, error } = await supabase.storage
      .from("classifieds")
      .remove([file]);
    if (error) {
      throw error;
    }
    return data;
  },
};

export default storageService;
